import React, { Component } from 'react'
import $ from 'jquery';
import 'datatables.net';


export const RefreshData = (idTable, data) => {
    let datatable = $(`#${idTable}`).DataTable();

    datatable.clear();
    datatable.rows.add(data);
    datatable.draw();
}

export const DeleteRow = (idTable, idRow) => {
    $(`#${idTable}`).DataTable().row(`#id_${idRow}`).remove().draw()
};

class DataTable extends Component {
    /*
        data                : Source data
        coloumn             : menentukan coloumn dari source data
        coloumnDefs         : medifikasi isi dari field coloumn
        idRow               : menentukan id tiap baris, berfungsi untuk delete baris
        idTable             : menentukan ID dari table 
        fixedWidthColoumn   : membuat lebar kolom dapat ditentukan dengan PX 
        isDisplay           : menentukan table ditampilkan atau di hide,
        dataLength          : set default display length
    */

    componentDidMount() {
        $(`#${this.props.idTable}`).DataTable(
            {
                responsive: true,
                autoWidth : false,
                data : this.props.data,
                columns : this.props.coloumn,
                rowId: this.props.idRow ? (e) => {return `id_${e[this.props.idRow]}`} : 'id',
                columnDefs: [ ...this.props.coloumnDefs, { "targets": 'nosort', "orderable": false } ],
                aaSorting : [], 
                pageLength : this.props.dataLength,
                lengthMenu : [this.props.dataLength, 25, 50, 100],
                pagingType: 'full_numbers',
                sFilterInput : "form-control yourClass",
                sLengthSelect : "form-control yourClass",
                language: {
                    search : "",
                    searchPlaceholder : "Cari Disini...",
                    emptyTable : 'Tidak Ada Data Yang Tersedia',
                    zeroRecords : 'Tidak Ada Data Yang Ditemukan',
                    lengthMenu : "Menampilkan _MENU_ Entri",
                    processing : 'Memproses...',
                    paginate: {
                        first:    "<span class='fa fa-angle-double-left'></span>",
                        previous: "<span class='fa fa-angle-left'></span>",
                        next:     "<span class='fa fa-angle-right'></span>",
                        last:     "<span class='fa fa-angle-double-right'></span>"
                    }
                }
            }
        );

        $(`#${this.props.idTable}_length, #${this.props.idTable}_filter`).wrapAll( "<div class='header-datatable' />");
        $('.header-datatable').append('<div class="clear"></div>');
        $(`#${this.props.idTable}`).wrapAll( "<div class='table-responsive' />");
    } 

    render() {
        return (
            <div className={`dataTableWrapper ${this.props.fixedWidthColoumn ? 'fixedWidthColoumn':''} ${this.props.isDisplay ? 'd-block' : 'd-none'}`}> 
                <table id={this.props.idTable} className="display" width="100%"  /> 
            </div>
        )
    }

}


DataTable.defaultProps = {
    idTable : 'tblData',
    isDisplay : true,
    dataLength : 10
}
export default DataTable;